import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';

var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from '~/api/api.js';
import upload from '~/components/upload.vue';
import isButton from '~/components/button.vue';
import moment from 'moment';
var miniToastr = void 0;
var Datepicker = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
  Datepicker = require('vuejs-datepicker');
}
var userData = '';
var initData = function initData() {
  _this.vendorData = '';
  _this.projectFile = [];
  var taskModel = {
    prodTaskName: '',
    prodDetail: '',
    reqLeadTime: 0,
    estStartDate: '',
    estFinishDate: '',
    vendorID: '',
    vendorName: '',
    projectFile: [],
    prodTaskStatus: 'Wait'
  };
  return taskModel;
};
export default {
  middleware: ['auth'],
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: '',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          params = _ref.params,
          error = _ref.error;
      var l, value1, files, listTask, partner;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              l = store.state.authUser;

              userData = l;

              _context.next = 4;
              return API.setToken(userData.tokenID);

            case 4:
              _context.next = 6;
              return API.listTaskOfProject(params.id);

            case 6:
              value1 = _context.sent;

              if (!(value1.data.flag === false)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt('return', error({ statusCode: 401, message: value1.data.message }));

            case 9:
              _context.next = 11;
              return API.listFileOrProject(params.id);

            case 11:
              files = _context.sent;
              listTask = value1.data.datas;
              _context.next = 15;
              return API.listPartner();

            case 15:
              partner = _context.sent;
              return _context.abrupt('return', {
                dataID: params.id,
                listTask: listTask,
                tokenData: userData,
                btnState: true,
                projectFile: [],
                files: files.data.datas,
                listPartner: partner.data.datas
              });

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      taskModel: initData(),
      listTask: [],
      tokenData: userData,
      listPartner: '',
      vendorData: ''
    };
  },

  watch: {
    'taskModel.estStartDate': function taskModelEstStartDate() {
      this.taskModel.estStartDate = moment(this.taskModel.estStartDate).format('YYYY-MM-DD');
    },
    'taskModel.estFinishDate': function taskModelEstFinishDate() {
      this.taskModel.estFinishDate = moment(this.taskModel.estFinishDate).format('YYYY-MM-DD');
    }
  },
  methods: {
    customFormatter: function customFormatter(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },

    loadData: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var value1;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return API.listTaskOfProject(id);

              case 2:
                value1 = _context2.sent;

                this.listTask = value1.data.datas;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadData(_x2) {
        return _ref3.apply(this, arguments);
      }

      return loadData;
    }(),
    createProdTask: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var btn, items, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _file, result;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                btn = this.$refs.btnCreate;

                if (!(this.taskModel.prodTaskName === '')) {
                  _context3.next = 5;
                  break;
                }

                this.showLoginError({ message: 'Production task name is required' });
                btn.enabled();
                return _context3.abrupt('return');

              case 5:
                if (!(this.taskModel.prodDetail === '')) {
                  _context3.next = 9;
                  break;
                }

                this.showLoginError({ message: 'Production task detail is required' });
                btn.enabled();
                return _context3.abrupt('return');

              case 9:
                if (!(this.taskModel.reqLeadTime === '')) {
                  _context3.next = 13;
                  break;
                }

                this.showLoginError({ message: 'Request lead time is required' });
                btn.enabled();
                return _context3.abrupt('return');

              case 13:
                if (!(this.taskModel.vendorID === '')) {
                  _context3.next = 17;
                  break;
                }

                this.showLoginError({ message: 'Partner is required' });
                btn.enabled();
                return _context3.abrupt('return');

              case 17:
                items = this.$refs.upload.getItems();
                _context3.next = 20;
                return API.setToken(this.tokenData.tokenID);

              case 20:
                formData = new FormData(); // Currently empty

                formData.append('prodTaskName', this.taskModel.prodTaskName);
                formData.append('estStartDate', this.taskModel.estStartDate);
                formData.append('estFinishDate', this.taskModel.estFinishDate);

                formData.append('vendorID', this.taskModel.vendorID);
                formData.append('vendorName', this.taskModel.vendorName);

                formData.append('prodDetail', this.taskModel.prodDetail);
                formData.append('reqLeadTime', this.taskModel.reqLeadTime);
                formData.append('isFinal', 'No');
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 32;
                for (_iterator = _getIterator(this.projectFile); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  file = _step.value;

                  formData.append('copyFile', file);
                }
                _context3.next = 40;
                break;

              case 36:
                _context3.prev = 36;
                _context3.t0 = _context3['catch'](32);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 40:
                _context3.prev = 40;
                _context3.prev = 41;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 43:
                _context3.prev = 43;

                if (!_didIteratorError) {
                  _context3.next = 46;
                  break;
                }

                throw _iteratorError;

              case 46:
                return _context3.finish(43);

              case 47:
                return _context3.finish(40);

              case 48:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 51;
                for (_iterator2 = _getIterator(items); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _file = _step2.value;

                  formData.append('quFile', _file.file, _file.file.name);
                }
                _context3.next = 59;
                break;

              case 55:
                _context3.prev = 55;
                _context3.t1 = _context3['catch'](51);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t1;

              case 59:
                _context3.prev = 59;
                _context3.prev = 60;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 62:
                _context3.prev = 62;

                if (!_didIteratorError2) {
                  _context3.next = 65;
                  break;
                }

                throw _iteratorError2;

              case 65:
                return _context3.finish(62);

              case 66:
                return _context3.finish(59);

              case 67:
                this.$refs.btnCreate.disabled();
                _context3.next = 70;
                return API.createProdTask(this.dataID, formData);

              case 70:
                result = _context3.sent;
                _context3.next = 73;
                return this.loadData(this.dataID);

              case 73:
                if (result.data.flag) {
                  this.showSuccess({ message: result.data.message });
                  this.taskModel = initData();
                  this.projectFile = [];
                  this.$refs.btnCreate.enabled();
                  this.$refs.upload.reset();
                  window.location.reload();
                } else {
                  this.showLoginError({ message: result.data.message });
                  this.$refs.btnCreate.enabled();
                }

              case 74:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[32, 36, 40, 48], [41,, 43, 47], [51, 55, 59, 67], [60,, 62, 66]]);
      }));

      function createProdTask() {
        return _ref4.apply(this, arguments);
      }

      return createProdTask;
    }(),
    clickCheckBox: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(index) {
        var obj, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                obj = this.listTask[index];
                _context4.next = 3;
                return API.setToken(this.tokenData.tokenID);

              case 3:
                _context4.next = 5;
                return API.putTaskToFinal(obj.prodTaskID);

              case 5:
                result = _context4.sent;

                if (result.data.flag) {
                  this.showSuccess({ message: result.data.message });
                } else {
                  this.showLoginError({ message: result.data.message });
                }
                _context4.next = 9;
                return this.loadData(this.dataID);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function clickCheckBox(_x3) {
        return _ref5.apply(this, arguments);
      }

      return clickCheckBox;
    }(),
    selectVendor: function selectVendor() {
      var index = this.vendorData;
      var data = this.listPartner[index];
      this.taskModel.vendorID = data.id;
      this.taskModel.vendorName = data.firstName;
    },
    createEditUrl: function createEditUrl(id) {
      return '/project/tasks/edit/' + id;
    }
  },
  components: {
    Datepicker: Datepicker,
    upload: upload,
    isButton: isButton
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/tasks/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/tasks/_id.vue
// module chunks = 33